export const LOGIN = '@login/LOGIN'
export const LOGIN_SUCCESS = '@login/LOGIN_SUCCESS'
export const LOGIN_FAILURE = '@login/LOGIN_FAILURE'
